var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell",on:{"click":_vm.onClickSelf}},[(_vm.a)?[_vm._v(_vm._s(_vm.text))]:void 0],2)
}
var staticRenderFns = []

export { render, staticRenderFns }